import ServiceApi from "../services/service.api";

const baseServiceUrl = `/api/v1/AmusementPackage`;


const ApiAmusementPackage = {
    getAmusementPackages: () => {
   
    const url = `${baseServiceUrl}`;
    
    return ServiceApi.get(url);
  },
};

export default ApiAmusementPackage;